import { CheckoutContractAttributes } from '../../models/global-checkout/checkout-contract-attribute.interface';
import { mockAchCheckoutPricing } from './ach-checkout-pricing.mock';
import { mockCcCheckoutPricingNoDiscount } from './cc-checkout-pricing-no-discount.mock';
import { mockCcCheckoutPricing } from './cc-checkout-pricing.mock';

export const mockCheckoutContractAttributes: CheckoutContractAttributes = {
  productVariantId: '13333',
  subscription: {
    cc: {
      ...mockCcCheckoutPricing,
      discountProfileAttributes: {
        ccDiscountCodeApplied: 'D50P2M',
        netAmountBeforeDiscount: 1000,
        netFirstPaymentAmountAfterPromotionalPeriod: 300,
        discountTerm: 6,
        discountPercentage: 0.2,
      },
    },
    ach: {
      ...mockAchCheckoutPricing,
      discountProfileAttributes: {
        achDiscountCodeApplied: 'achDiscountCode',
        netAmountBeforeDiscount: 1000,
        netFirstPaymentAmountAfterPromotionalPeriod: 300,
        discountTerm: 6,
        discountPercentage: 0.2,
      },
    },
  },
  annualPrepay: {
    cc: mockCcCheckoutPricingNoDiscount,
    ach: {
      ...mockAchCheckoutPricing,
      discountProfileAttributes: {
        achDiscountCodeApplied: 'achDiscountCode',
        netAmountBeforeDiscount: 1000,
        netFirstPaymentAmountAfterPromotionalPeriod: 300,
      },
    },
  },
  periodOfCover: 12,
  levelOfCoverCode: '321',
  effectiveDate: '2025-04-29',
  thirdPartyContractExpiryDate: '2025-04-29',
};
